import { ANBIMA_STATUS } from '@modules/consolidator/constants/anbima-status'
import { CINZA_SEM_INFORMACAO } from '@modules/consolidator/constants/status-color-tokens'

// Mapa único status ANBIMA → cor, compartilhado entre a lista
// (consolidated-tables.vue, via prop `color` do BaseStatus) e o
// detalhamento (detalhamento-alocacao-estrategica.vue, via estilo inline).
//
// ATENÇÃO — semântica mista por chave:
// - 'Acima do Risco' / 'Dentro do Risco' / 'Próximo do Risco': NOME de prop
//   do BaseStatus ('danger'/'success'/'warning-new'), não é CSS válido
//   sozinho — BaseStatus resolve para var(--danger) etc internamente
//   (_base-status.vue:formatColor). Usado só pela lista.
// - 'Não Configurado': valor CSS DIRETO (hex), consumido tanto pela lista
//   (BaseStatus aceita hex cru, formatColor: `if (color.includes('#'))
//   return color`) quanto pelo detalhamento (:style inline). Hex, não
//   var(--secondary): o :root gera --secondary a partir de $theme-colors
//   (src/design/_vars.sass:45 e :75), onde secondary = $gray-4 = #C7BBC9 —
//   e não do $secondary: #8e8e8e da linha 34.
export const ANBIMA_RISCO_COLOR = Object.freeze({
  [ANBIMA_STATUS.ACIMA]: 'danger',
  [ANBIMA_STATUS.DENTRO]: 'success',
  [ANBIMA_STATUS.PROXIMO]: 'warning-new',
  [ANBIMA_STATUS.NAO_CONFIGURADO]: CINZA_SEM_INFORMACAO,
})
